// External Dependencies
import React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

const ClockIcon = props => (
  <SvgIcon viewBox="0 0 64 64" {...props}>
    <g id="Layer_1">
      <g>
        <circle
          cx="32"
          cy="32"
          fill="#E0E0D1"
          r="32"
        />
      </g>
      <g opacity="0.2">
        <path
          d="M32,16c9.925,0,18,8.075,18,18s-8.075,18-18,18s-18-8.075-18-18S22.075,16,32,16z M32,12c-12.15,0-22,9.85-22,22s9.85,22,22,22s22-9.85,22-22S44.15,12,32,12L32,12z"
          fill="#231F20"
        />
      </g>
      <g>
        <path
          d="M32,14c9.925,0,18,8.075,18,18s-8.075,18-18,18s-18-8.075-18-18S22.075,14,32,14 M32,10c-12.15,0-22,9.85-22,22s9.85,22,22,22s22-9.85,22-22S44.15,10,32,10L32,10z"
          fill="#C75C5C"
        />
      </g>
      <g opacity="0.2">
        <g>
          <path
            d="M40,44c-0.512,0-1.023-0.195-1.414-0.586L30,34.829V26c0-1.104,0.896-2,2-2s2,0.896,2,2v7.171l7.414,7.415c0.781,0.781,0.781,2.047,0,2.828C41.023,43.805,40.512,44,40,44z"
            fill="#231F20"
          />
        </g>
      </g>
      <g>
        <path
          d="M40,42c-0.512,0-1.023-0.195-1.414-0.586L30,32.829V24c0-1.104,0.896-2,2-2s2,0.896,2,2v7.171l7.414,7.415c0.781,0.781,0.781,2.047,0,2.828C41.023,41.805,40.512,42,40,42z"
          fill="#4F5D73"
        />
      </g>
    </g>
    <g id="Layer_2" />
  </SvgIcon>
);

export default ClockIcon;



/** WEBPACK FOOTER **
 ** ./src/shared/icons/clock.js
 **/